import { render, staticRenderFns } from "./InteractionTypeForm.vue?vue&type=template&id=d0a6b9c2&scoped=true"
import script from "./InteractionTypeForm.vue?vue&type=script&lang=js"
export * from "./InteractionTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a6b9c2",
  null
  
)

export default component.exports